import React, { useEffect, useState } from "react";

const SvgLoader = ({ url, className = "" }) => {
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    const fetchSvg = async () => {
      try {
        const response = await fetch(url);
        let text = await response.text();
        text = text.replace(/fill="none"/g, 'fill="currentColor"');

        setSvgContent(text);
      } catch (error) {
        console.error("Failed to fetch SVG:", error);
      }
    };

    fetchSvg();
  }, [url]);

  if (!svgContent) {
    return <div>
        <img src="https://storage.cloud.google.com/meshkey_cms/plant_finder/Escaping%20ball.gif" alt="Loading..." className="w-8 h-8 animate-spin" />
    </div>;
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default SvgLoader;
